import { fetcher } from '@commenda/utils';

import { TIndirectTaxProductsBulkDeleteProps } from './types';

type BulkDeleteProductResult = {
  success: boolean;
  message?: string;
  error?: string;
};

export async function bulkDeleteIndirectTaxProducts(
  body: TIndirectTaxProductsBulkDeleteProps,
  token?: string
): Promise<BulkDeleteProductResult> {
  try {
    const response = await fetcher(
      'new-sales-tax/products/bulk/delete',
      { method: 'POST', body },
      token
    );

    if (!response.ok) {
      const errorData = await response.json();
      return {
        success: false,
        error: errorData.message || 'Failed to bulk delete products',
      };
    }

    const data = await response.json();
    return {
      success: true,
      message: data.message || 'Products deleted successfully',
    };
  } catch (error) {
    const errorMessage =
      error instanceof Error ? error.message : 'Failed to bulk delete products';
    return { success: false, error: errorMessage };
  }
}
